/**
 * AccordionItem
 * @returns <AccordionItem />
 */
import { useState, useRef } from "react"

import Button from "./Button";

const AccordionItem = ({ item, type, isOpen, children, clicked, isValid, toggle, accordionItemLabel }) => {
    const contentEl = useRef();
    const { label, content, hasHtml } = item;
    const [isActive, setIsActive] = useState(false);

    const onClickHandler = (e) => {
        setIsActive(!isActive)
    }

    if (type === "checkout") {
        return (
            <div className={`checkout__item ${isOpen ? "--active" : ""}`}>
                <div className="checkout__item__container">
                    <div className="checkout__label-container">
                        {isValid && <img src={`${window._env_.STATIC_HOST}/static/website/images/icon-check-with-background.svg`} alt="" />}
                        <p className="checkout__item__label">{accordionItemLabel}</p>
                    </div>

                    {isValid && <Button tag="link" text="Modificar" onClick={toggle} />}
                </div>

                <div className="checkout__item__content" ref={contentEl} style={isOpen ? { maxHeight: "99999px", marginTop: "1.5rem" } : { maxHeight: "0px" }}>
                    {children}

                    <Button tag="link" text="Continuar" onClick={clicked || onClickHandler} extraClass={"button-continue"} />
                </div>

            </div>
        )
    } else if (type === "filters") {
        return (
            <div className={`accordion__item --filter ${isActive ? "--active" : ""}`}>
                <div className="accordion__item__container" onClick={onClickHandler}>
                    <p className="accordion__item__label">{label}</p>

                    <i className="arrow"></i>
                </div>

                <div className="accordion__item__content" ref={contentEl} style={isActive ? { height: contentEl.current.scrollHeight, marginTop: "1.25rem" } : { height: "0px" }}>
                    {content}
                </div>
            </div>
        )
    } else {
        return (
            <div className={`accordion__item ${isActive ? "--active" : ""}`}>
                <div className="accordion__item__container" onClick={onClickHandler}>
                    <p className="accordion__item__label">{label}</p>

                    <i className="arrow"></i>
                </div>

                <div className="accordion__item__content" ref={contentEl} style={isActive ? { height: contentEl.current.scrollHeight, marginTop: "1.25rem" } : { height: "0px" }}>
                    {hasHtml
                        ?
                        <div dangerouslySetInnerHTML={{ __html: content }}></div>
                        :
                        content
                    }
                </div>
            </div>
        )
    }
}

export default AccordionItem